/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseStoreStatus } from '../../models/api-response-store-status';
import { StoreStatusUpdate } from '../../models/store-status-update';

export interface UpdateStoreStatus$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
      body: StoreStatusUpdate
}

export function updateStoreStatus(http: HttpClient, rootUrl: string, params: UpdateStoreStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseStoreStatus>> {
  const rb = new RequestBuilder(rootUrl, updateStoreStatus.PATH, 'put');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseStoreStatus>;
    })
  );
}

updateStoreStatus.PATH = '/v1/api/ui/company/store-status';
